import * as firebase from 'firebase/app';

import "firebase/database";
import "firebase/storage";
import "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDN4VPl6btDW5VhR5ylbkDHXpf-CExDRWM",
    authDomain: "crimemap-c90e7.firebaseapp.com",
    databaseURL: "https://crimemap-c90e7.firebaseio.com",
    projectId: "crimemap-c90e7",
    storageBucket: "crimemap-c90e7.appspot.com",
    messagingSenderId: "587005702154",
    appId: "1:587005702154:web:eba3cf6f9ea1da59c2eff3",
    measurementId: "G-517DJE0LMY"
};

export function start() {
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();
}

export function getStorageDownloadUrl(path, dowloadResult) {
    firebase.storage()
        .ref(path)
        .getDownloadURL()
        .then(url => {
            dowloadResult(url)
        })
}

export function getDatabaseSnapshot(path, snapshotResult){
    firebase.database().ref()
    .child(path)
    .once('value')
    .then(snapshot => {
        snapshotResult(snapshot);
    });
}